import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Formatter } from "../../utils/formatter";
import { Link } from "../util/Clickable";
import { Image } from "../util/Image";
import { IntlText, LinedText } from "../util/Text";

class InformationsList extends Component {
  getInfo = (information, lang) => {
    if (information == null) {
      return {};
    }
    const desc = information.information_descs.find((desc) => {
      return desc.lang == lang;
    });
    return Object.assign({}, desc, information);
  };

  render = () => {
    if (this.props.informations == null) {
      return (
        <div className="uk-text-center">
          <span data-uk-spinner="ratio: 3"></span>
        </div>
      );
    } else if (this.props.informations.length <= 0) {
      return (
        <div>
          <h3>
            <IntlText id="lists.informations.no" />
          </h3>
        </div>
      );
    }

    return (
      <div className="uk-overflow-auto">
        <table className="uk-table uk-table-small uk-table-striped">
          <thead>
            <tr>
              <th className="uk-table-shrink">
                <IntlText id="lists.informations.post_date" />
              </th>
              <th className="uk-table-shrink">
                <IntlText id="lists.informations.thumnail" />
              </th>
              <th className="uk-table-expand">
                <IntlText id="lists.informations.description" />
              </th>
              {this.props.editing && (
                <th className="uk-table-shrink">
                  <IntlText id="lists.informations.action" />
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {this.props.informations.map((information, key) => {
              const data = Formatter.mergeDesc(
                information,
                information.information_descs,
                this.props.lang ? this.props.lang : this.props.language.view,
              );
              return (
                <tr key={information.id}>
                  <td>
                    <div className="uk-width-small">
                      {data.posted_at &&
                        moment(data.posted_at).format("YYYY-MM-DD")}
                    </div>
                  </td>
                  <td>
                    <div className="uk-width-small">
                      <Image className="uk-width-1-1" src={data.thumnail_url} />
                    </div>
                  </td>
                  <td>
                    <h3 className="uk-margin-small">{data.title}</h3>
                    <LinedText
                      className="uk-margin-small"
                      text={data.description}
                    />
                  </td>
                  {this.props.editing && (
                    <td>
                      <div className="uk-width-small uk-text-center">
                        <Link
                          className="uk-icon-button uk-button-default uk-margin-small-right"
                          data-uk-icon="icon:pencil;"
                          onClick={() => {
                            this.props.onEdit && this.props.onEdit(data);
                          }}
                        />
                        <Link
                          className="uk-icon-button uk-button-danger"
                          data-uk-icon="icon:close;"
                          onClick={() => {
                            this.props.onDelete && this.props.onDelete(data);
                          }}
                        />
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    language: state.language,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InformationsList),
);
